export default ["Elite Solutions", "Hub", "Employee"].map(value => [
  value,
  value
]);
